/**
 * @name ArtistsController
 * @description Controller for artists.
 * @param {object} Artists The artists service.
 * @param {object} Association The association service
 * @param {object} Events The events service
 * @param {object} $uibModal The $uibModal service from ui Bootstrap
 * @param {object} AlertMessages The AlertMessages service
 * @param {object} RESPONSE_MESSAGES The RESPONSE_MESSAGES constant
 * @param {object} Session The Session service
 */
function ArtistsController(
  Artists,
  Association,
  Events,
  $uibModal,
  AlertMessages,
  RESPONSE_MESSAGES,
  Session
) {
  let vm = this;
  vm.$onInit = function() {
    vm.events = Events;
    vm.cancelInvite = cancelInvite;
    vm.updateArtistAssociation = updateArtistAssociation;
    vm.expireArtistAssociation = expireArtistAssociation;
    vm.session = Session;
  };

  /**
  * @name refresh
  * @description Get shop artists
  */
  function refresh() {
    Artists.refreshArtists().then(function(artists) {
      vm.artists = artists;
    });
  }

  /**
   * @name updateArtistAssociation
   * @description Function to update an artist association through a modal
   * @param {object} artist The artist to edit
   */
  function updateArtistAssociation(artist) {
    let modalInstance = $uibModal.open({
      template: require('./update/update-artist-modal.template.html'),
      animation: true,
      controller: 'UpdateArtistModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        artist: function() {
          return artist;
        }
      }
    });
    modalInstance.result.then(
      function() {
        refresh();
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
   * @name expireArtistAssociation
   * @description Function to expire an artist association through a modal
   * @param {object} artist The artist to edit
   */
  function expireArtistAssociation(artist) {
    let modalInstance = $uibModal.open({
      template: require('./expire/expire-artist-modal.template.html'),
      animation: true,
      controller: 'ExpireArtistModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        artist: function() {
          return artist;
        }
      }
    });
    modalInstance.result.then(
      function() {
        refresh();
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
  * @name cancelInvite
  * @description Change association status to declined by shop
  * @param {object} collector The collector who's invite you want to cancel
  */
  function cancelInvite(collector) {
    Association.declineByShop(collector.association).then(function() {
      // Remove invited collector from the array
      for (let i = vm.artists.invited.length - 1; i >= 0; i--) {
        if (vm.artists.invited[i].id === collector.id) {
          vm.artists.invited.splice(i, 1);
        }
      }

      // Refresh the list of collectors on the template
      refresh();
    });
  }
}

angular.module('inkfinder').controller('ArtistsController', ArtistsController);



// WEBPACK FOOTER //
// ./components/artists/artists.controller.js